module.exports = __webpack_public_path__ + "static/media/justyna.4cd61a24.jpg";